import { get } from 'lodash'
import { META_FALLBACK_IMAGE, META_FALLBACK_DESCRIPTION } from './../constants'

const getEntryType = typeName => {
  switch (typeName) {
    case 'Store': {
      return 'Retail'
    }
    default: {
      return 'Website'
    }
  }
}

export default ({ entry, url }) => ({
  type: entry.category || getEntryType(entry.__typename),
  title: entry.title,
  description: entry.shortDescription || META_FALLBACK_DESCRIPTION,
  image: get(entry, 'mobileImage.src', META_FALLBACK_IMAGE),
  url,
})
